<div class="section-header">
    <div class="title">
        Für MPS ausgewählte Modelle
    </div>


    <div class="print-smart-icon">
        <img [res-src]="'./assets/img/logo-print-smart/icon_mps.png'" [res-sizes]="['2x', '3x']"/>
    </div>

</div>

<div class="error-viewer" *ngIf="showValidationError()">
    Für MPS - Stückzahlbasiert und MPS - Seitenpreisbasiert sind MPS-Geräte erforderlich.
</div>

<div class="table"
     [ngClass]="{'notify-change' : notifyChange( pUNFEnum.SUPPLIES) }">
    <div class="table-header"
         [ngClass]="{'notify-change' : notifyChange( pUNFEnum.SUPPLIES)}"
         *ngIf="getSupplyAcquisitionMode() === supplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT">
        <div class="table-header-column">Anzahl</div>
        <div class="table-header-column">Artikel</div>
        <div class="table-header-column">Stückpreis</div>
        <div class="table-header-column">Sonderpreis Bemerkung</div>
    </div>

    <div class="table-body"
         [ngClass]="{  'stuck-layout': getSupplyAcquisitionMode() === supplyAcquisitionTypeEnum.MPS_BASED_ON_PAGE_PRICE,
                      'price-layout': getSupplyAcquisitionMode() === supplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT
                      }">

        <ng-container
            *ngFor="let deviceContainer of getAvailablePrintSmartDeviceWithSupplyContainers() ; let i = index">

            <div class="table-row">

                <div class="amount-column-cell"
                     *ngIf="getSupplyAcquisitionMode() === supplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT ||
                 ( getSupplyAcquisitionMode() === supplyAcquisitionTypeEnum.MPS_BASED_ON_PAGE_PRICE) ">
                    <app-amount-input [(ngModel)]="deviceContainer.deviceAmount.amount"
                                      [showIcon]="false"
                                      [name]="deviceContainer.id + 'amount_pssst'"
                                      disabled>
                    </app-amount-input>
                </div>

                <div class="column-article-cell">
                    <app-product-label [orderItemContainer]="deviceContainer"
                                       [showTitle]="false">
                    </app-product-label>
                </div>

<!--              removed because of  https://minntgmbh.atlassian.net/browse/BROT-1047 -->
<!--                <div class="button-cell"-->
<!--                     *ngIf="getSupplyAcquisitionMode() === supplyAcquisitionTypeEnum.MPS_BASED_ON_PAGE_PRICE && !isInternalUser()">-->
<!--                    <bd-checkbox-rounded [name]="'select' + deviceContainer.id"-->
<!--                                         [(ngModel)]="deviceContainer.containerSharedMetadata.addToRequestedPrintSmartDeviceSupplyOrderList">-->
<!--                    </bd-checkbox-rounded>-->
<!--                </div>-->
            </div>

            <!--   when itemToOrder contains supplies add also rows for each of them -->
            <ng-container *ngIf="getSupplyAcquisitionMode() === supplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT">
                <!--            only for MPS - Stückzahlbasiert supply rows will be visible-->
                <div class="table-row accessory" *ngFor="let supplyContainer of deviceContainer.mpsSupplies">
                    <div class="amount-column-cell">
                        <app-amount-input
                            [(ngModel)]="supplyContainer?.parentPrintSmartDedicatedSupplyAmount.amount"
                            [showIcon]="false"
                            [minNumber]="0"
                            [name]="supplyContainer.id + 'amount_pssst'"
                            disabled
                            class="supply-amount-input">
                        </app-amount-input>
                    </div>

                    <div class="column-article-cell">
                        <div class="label-container">
                            <app-product-label [orderItemContainer]="supplyContainer"></app-product-label>
                        </div>
                    </div>

                </div>


            </ng-container>


        </ng-container>
    </div>
</div>
